import React, { useState } from "react";
import { Typography } from "@mui/material";
import SavingCalculator from "./Calculator/SavingCalculator";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { stepOneData, helpData } from "./stepOneContent";
import { headingStyle, paragraphStyle } from "../../../../calculatorStyleData";

const StepOne = () => {
  // State to track visibility of the div
  const [isVisible, setIsVisible] = useState(false);

  // handling visibility of need help container

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };
  return (
    <>
      <div id="step-one">
        <div className="mt-3 d-flex flex-column gap-3">
          <Typography sx={paragraphStyle}>{stepOneData[0].paraOne}</Typography>
          <div className="d-flex flex-column gap-3">
            <Typography sx={headingStyle}>
              <strong> {stepOneData[0].paraTow}</strong>
            </Typography>
            <Typography sx={paragraphStyle}>
              {stepOneData[0].paraThree}
            </Typography>
          </div>
        </div>
        <div id="list_data" className="mt-3">
          <Typography sx={headingStyle} className="pb-3">
            <strong>{stepOneData[1].heading}</strong>
          </Typography>
          <Typography sx={paragraphStyle}>
            {stepOneData[1].subheading}
          </Typography>
          <div>
            <ol
              style={{
                listStyle: "number",
                fontSize: 16,
                color: "#1f1f1f",
                lineHeight: "24px",
              }}
              className=" archivo "
            >
              {stepOneData[1].personal_lone &&
                stepOneData[1].personal_lone.map((item, index) => (
                  <li key={index} className="mt-3">
                    <Typography sx={paragraphStyle}>
                      <strong>{item.heading}</strong> {item.description}
                    </Typography>
                  </li>
                ))}
            </ol>
          </div>
        </div>
        <section className="mt-5">
          <SavingCalculator />
        </section>
        {/* Need Help Information */}
        <div className="need_help_container  pt-3">
          <div
            style={{ border: "1px solid #8A8A8A" }}
            className="w-100 border-start-0 border-end-0 "
          >
            <div
              className="needhelp_box py-3 d-flex justify-content-between w-100"
              onClick={toggleVisibility}
            >
              <Typography
                sx={{
                  width: "100%",
                  fontSize: 16,
                  fontWeight: 700,
                  lineHeight: "24px",
                  fontFamily: "'Archivo', sans-serif",
                  cursor: "pointer",
                }}
              >
                {helpData[0].needhelp}
              </Typography>
              <Typography className="w-25 text-end" sx={{ cursor: "pointer" }}>
                <FontAwesomeIcon
                  icon={isVisible ? faChevronUp : faChevronDown}
                />
              </Typography>
            </div>

            {/* Conditional rendering of the text */}
            {isVisible &&
              helpData.map((item) => (
                <div
                  key={item.id}
                  className=" faq_container d-flex border-start-0 border-end-0 "
                >
                  <div className="w-100">
                    <div className="information_box no-scrollbar mt-3 ">
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "20px",
                            sm: "20.5183px",
                            md: "22.5046px",
                            lg: "24px",
                          },
                          fontWeight: 700,
                          lineHeight: {
                            xs: "26px",
                            sm: "26.6738px",
                            md: "28.9559px",
                            lg: "32px",
                          },
                          letterSpacing: "0.08px",
                          fontFamily: "'Archivo', sans-serif",
                          textAlign: "start",
                        }}
                      >
                        {item.title}
                      </Typography>

                      {/* Hidden text paras */}
                      {item.information.map((info, index) => (
                        <React.Fragment key={index}>
                          <Typography
                            className="fw-bold"
                            sx={{
                              fontFamily: "'Archivo', sans-serif",
                              fontSize: "16px",
                              lineHeight: "24px",
                              letterSpacing: "normal",
                              textAlign: "start",
                              padding: "0.8rem 0",
                            }}
                          >
                            {info.subtitle}
                          </Typography>
                          <Typography
                            sx={{
                              fontFamily: "'Archivo', sans-serif",
                              fontSize: "16px",
                              lineHeight: "24px",
                              letterSpacing: "normal",
                              textAlign: "start",
                            }}
                          >
                            {info.infotext}
                          </Typography>
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default StepOne;
